import React from 'react';
import { Button } from 'antd';
import { useDispatch } from 'react-redux';
import { ReactComponent as ShareSvg } from '@assets/icons/share.svg';
import { useTypedSelector } from '@hooks';
import { toggleShareAssetModal } from '@redux/actions/modalAction';
import DropdownDecisions from '@components/MediaViewerHeader/components/DropdownDecisions';
import AssetsActionMenu from '@pages/MediaViewer/components/AssetsActionMenu';
import ApprovalWorkflowButton from '@components/MediaViewerHeader/components/ApprovalWorkflowButton';
import ApprovalWorkflowDeadline from '@components/MediaViewerHeader/components/ApprovalWorkflowDeadline';
import { LgWidth } from '@components/Responsive';

type HeaderActionsProps = {
  isShowShareBtn?: boolean;
  isShowDeadline?: boolean;
};

function HeaderActions({
  isShowShareBtn = true,
  isShowDeadline = false
}: HeaderActionsProps) {
  const dispatch = useDispatch();
  const asset = useTypedSelector(({ mediaViewer }) => mediaViewer.assets);
  const selectedVersion = useTypedSelector(
    ({ mediaViewer }) => mediaViewer.selectedVersion
  );

  const openShareLinkModal = () => {
    if (selectedVersion && asset) {
      dispatch(
        toggleShareAssetModal({
          visible: true,
          campaignId: asset?.campaignId || '',
          assets: [{ id: asset.id, versionId: selectedVersion.id }],
          defaultName: asset?.asset?.versions[0]?.name || ''
        })
      );
    }
  };

  const isLastVersion =
    selectedVersion?.versionNumber === asset?.asset?.versionsCount;
  const showApprovalButton = asset && selectedVersion;

  return (
    <div className="media_viewer_actions">
      {isShowDeadline && (
        <ApprovalWorkflowDeadline
          approvalWorkflowId={asset?.asset?.approvalWorkflow?.id || ''}
        />
      )}
      <AssetsActionMenu />
      {showApprovalButton && (
        <LgWidth>
          <ApprovalWorkflowButton
            asset={asset}
            isLastVersion={isLastVersion}
            selectedVersion={selectedVersion}
          />
        </LgWidth>
      )}
      <DropdownDecisions />
      {isShowShareBtn && (
        <Button
          type="primary"
          className="media_viewer_header-btn-primary media_viewer_header-share-btn"
          onClick={openShareLinkModal}
        >
          <ShareSvg />
          <LgWidth>Share</LgWidth>
        </Button>
      )}
    </div>
  );
}

export default HeaderActions;
